import { getCurrentUserId } from "../useCurrentUser";

/**
 * Headere for skrivekall. Legger på X-User-Id fra innlogget bruker slik at
 * API-et kan attribuere endringen (updatedBy + AuditLog). Mock nå (/api/me),
 * ekte når Entra ID kommer — da byttes kilden til JWT-claims.
 */
export function jsonHeaders(): Record<string, string> {
  const uid = getCurrentUserId();
  const h: Record<string, string> = { "Content-Type": "application/json" };
  if (uid) h["X-User-Id"] = uid;
  return h;
}

export function userHeaders(): Record<string, string> {
  const uid = getCurrentUserId();
  return uid ? { "X-User-Id": uid } : {};
}
